import React from 'react';
import { USER_PERSONAS, USER_PERSONA_LABELS } from '../constants/userPersonas';

const UserPersonaPicker = ({
  value = [],
  onChange,
  disabled = false,
  className = '',
}) => {
  const selected = Array.isArray(value) ? value : [];

  const togglePersona = (persona) => {
    if (disabled || !onChange) return;

    if (selected.includes(persona)) {
      onChange(selected.filter((item) => item !== persona));
      return;
    }

    onChange([...selected, persona]);
  };

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 ${className}`}>
      {USER_PERSONAS.map((persona) => {
        const isSelected = selected.includes(persona);
        return (
          <button
            key={persona}
            type="button"
            disabled={disabled}
            onClick={() => togglePersona(persona)}
            className={`text-left px-3 sm:px-4 py-3 rounded-xl border-2 transition-all text-sm sm:text-base ${
              isSelected
                ? 'border-purple-500 bg-purple-50 text-purple-800 shadow-sm'
                : 'border-gray-200 bg-white text-gray-700 hover:border-purple-300 hover:bg-purple-50/50'
            } ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
            aria-pressed={isSelected}
          >
            <span className="font-medium">{USER_PERSONA_LABELS[persona]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default UserPersonaPicker;
